export class AffinityPartnerFlags {
    partnercode: string;
    utm_source: string;
    utm_medium: string;
    discount_percentage: any;
    enablePreSelectedProductFlow: boolean;
    eligibleProductsForPreSelection: [];
    partnerProducerCd?: string;
    narrowClassList: boolean;
    emailCapturedOnGetQuotePage?: string;
}
